// extracted by mini-css-extract-plugin
export default {"header":"Header_header__ZXqUN","heart":"Header_heart__-j+b+","beat":"Header_beat__OXssv"};